import * as THREE from "three";

import { TextureLoader, Vector3 } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import * as THREEx from "threex.domevents";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

//var fs = require("fs");


//var THREE = require('three') // require peer dependency
//Threex 
//var THREE2 = require('three'); // require peer dependency
//var THREEx= require('threex.domevents');

//initializeDomEvents(THREE2, THREEx);
// var THREE2 = require('three') // require peer dependency
// var initializeDomEvents = require('threex.domevents')
// var THREEx = {}
// var er = initializeDomEvents(THREE2, THREEx);

// Setup
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.25, 4200);
const renderer = new THREE.WebGLRenderer();
//var renderer = new THREE.WebGLRenderer( { alpha: true } );
//renderer.setClearColor( 0x000000, 0 )
const loader = new THREE.TextureLoader();
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);
camera.position.setZ(50);
camera.position.setX(200);
camera.position.setY(20);
let timestamp = 0;

// Lights
const pointLight = new THREE.PointLight(0xffffff, 2, 0, 2);
const ambientLight = new THREE.AmbientLight(0xffffff, 0.1);
pointLight.position.set(0, 0, 0);
scene.add(pointLight, ambientLight);

const hemiLight = new THREE.HemisphereLight( 0xffffff, 0x444444, 0.4 );
hemiLight.position.set( 0, 20, 0 );
scene.add( hemiLight );

const dirLight = new THREE.DirectionalLight( 0xffffff, 0.8 );
dirLight.position.set( - 3, 10, - 10 );
scene.add( dirLight )

// Mouse controls
const controls = new OrbitControls(camera, renderer.domElement);
controls.minDistance = 50;
controls.maxDistance = 1300;
controls.enabled = true;
const minPan = new THREE.Vector3(-400, -400, -400);
const maxPan = new THREE.Vector3(400, 400, 400);



//var domEvents	= new THREEx.DomEvents(camera, renderer.domElement);
//var domEvents = new Threex.DomEvents(camera, renderer.domElement);

var _v = new THREE.Vector3();

const x =50;
controls.addEventListener("change", function () {
	_v.copy(controls.target);
	controls.target.clamp(minPan, maxPan);
	_v.sub(controls.target);
	camera.position.sub(_v);
});

// Gonna use this later for asteriod belt and stuff
// const stars = () => {
// 	const geometry = new THREE.SphereGeometry(0.25, 24, 24);
//  	const material = new THREE.MeshStandardMaterial({ color: 0xffffff });
//  	const star = new THREE.Mesh(geometry, material);

// 	const [x, y, z] = Array(3)
// 			.fill()
//  		.map(() => THREE.MathUtils.randFloatSpread(100));

//  	star.position.set(x ** 2, y, z);
//  	scene.add(star);
// };
// Array(300).fill().forEach(stars);

 //Set background image
const bg = loader.load(require("../assets/milky1.jpg"));
 scene.background = bg;
const bgSphere = new THREE.Mesh(
	new THREE.SphereGeometry(2800, 100, 100),
	new THREE.MeshBasicMaterial({
		map: bg,
		side: THREE.DoubleSide,
		transparent: true, 
		opacity: 0.7,
	})
);
scene.add(bgSphere);
// const bggeo = new THREE.SphereGeometry(2000,100,100);
// const bdmat = new THREE.MeshStandardMaterial({
// map : TextureLoader.load("../assets/milky2.jpg"),
// side : THREE.DoubleSide,
// });
// const bg = new THREE.Mesh(bggeo,bdmat);


// scene.add(bg);
// const bg2 = loader.load(require("../assets/milky2.jpg"));
//  scene.background = bg2;
// const bgSphere2 = new THREE.Mesh(
// 	new THREE.BoxGeometry(3800, 3800, 3800),
// 	new THREE.MeshBasicMaterial({
// 		map: bg2,
// 		side: THREE.DoubleSide,
// 	})
// );
// scene.add(bgSphere2);

//  const loader2 = new GLTFLoader();
// let tt;
// loader.load('../assests/scene.gltf', function ( gltf ) {
//      tt = gltf.scene;
// 	 gltf.scene.scale.set(10, 10, 10);
// 	console.log("loaded");
// 	scene.add( gltf.scene);

// });



// Create all planets and add them to the scene
// sun
 const r=10;
 const sun = new THREE.Group();
const sunTexture = loader.load(require("../assets/sun.jpeg"));
const sunt = new THREE.Mesh(new THREE.SphereGeometry(r+40, 32, 32), new THREE.MeshBasicMaterial({ map: sunTexture , 
}));
sun.add(sunt);

const suncl = new THREE.SphereGeometry(r+40+5,32,32);
const sunclmat = new THREE.MeshPhongMaterial({
	map: loader.load(require("../assets/sun.jpeg")),
	//color : new THREE.Color("#FDB813"),
	transparent : true,
	opacity : .7,
	shininess : 100,
});

 const Suncloud = new THREE.Mesh(suncl,sunclmat);
  sun.add(Suncloud);
scene.add(sun);
// domEvents.addEventListener(sun, 'click', function(event){
//     console.log('you clicked on the mesh')
// }, false)

// //parker solar probe
// const probe = new THREE.Group();
// //const probeTex = loader.load();
// const box = new THREE.Mesh(new THREE.BoxGeometry(10,10,10), new THREE.MeshBasicMaterial({map:sunTexture}));

// probe.add(box);
// probe.position.set(0, 0, 85);
// scene.add(probe);


//new sun

// const color =new THREE.Color("#FDB813");

// const sunGeo = new THREE.IcosahedronGeometry(52,15);
// const mat = new THREE.MeshBasicMaterial({color:color});
// const sun2 = new THREE.Mesh(sunGeo,mat);

// sun2.position.set(0,0,0);
// sun2.layers.set(1);
// scene.add(sun2);
// fs.readFile("../assets/scene.gltf", function(err, buf) {
// 	console.log(buf.toString());
//   });

const loader3 = new GLTFLoader();
//console.log({loader3});
loader3.load(
	
    '../assets/scene.gltf',
    ( gltf ) => {
        // called when the resource is loaded
        scene.add( gltf.scene );
    },
    ( xhr ) => {
        // called while loading is progressing
        console.log( `${( xhr.loaded / xhr.total * 100 )}% loaded` );
		
    },
    ( error ) => {
        // called when loading has errors
        console.error( 'An error happened', error );
    },
);



// venus
const venusGeo = new THREE.SphereGeometry(4+r, 32, 32);
const venusTexture = loader.load(require("../assets/venus.jpeg"));
const venusMaterial = new THREE.MeshStandardMaterial({ map: venusTexture });
const venus = new THREE.Mesh(venusGeo, venusMaterial);
venus.position.set(0, 0, 80);
scene.add(venus);
// venus orbit path visualization
const venusPath = new THREE.RingGeometry(80+2*x, 80.5+2*x, 100);
const venusPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});

// mercury
const mercuryGeo = new THREE.SphereGeometry(2+r, 32, 32);
const mercuryTexture = loader.load(require("../assets/mercury.jpeg"));
const mercuryMaterial = new THREE.MeshStandardMaterial({ map: mercuryTexture });
const mercury = new THREE.Mesh(mercuryGeo, mercuryMaterial);
mercury.position.set(0, 0, 60);
scene.add(mercury);
// mercury orbit path visualization
const mercuryPath = new THREE.RingGeometry(60+x, 60.5+x, 100);
const mercuryPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const mercuryPathMesh = new THREE.Mesh(mercuryPath, mercuryPathMaterial);
mercuryPathMesh.rotateX(Math.PI / 2);
mercuryPathMesh.rotateY(-0.15);
scene.add(mercuryPathMesh);


const venusPathMesh = new THREE.Mesh(venusPath, venusPathMaterial);
venusPathMesh.rotateX(Math.PI / 2);
scene.add(venusPathMesh);

//earth new
const earthSys = new THREE.Group();


const s = 50;
const tilt = 0.41;

const earthCol = loader.load(require("../assets/earth.jpeg"));
const earthBump = loader.load(require("../assets/earthBm.jpg"));
const earthSpec =loader.load (require("../assets/earthSp.jpg"));

const earthGeo2 = new THREE.SphereGeometry(r+5,s,s);
const earthmat = new THREE.MeshPhongMaterial({
	map : earthCol,
	bumpMap : earthBump,
	bumpScale : 0.5,
	specularMap : earthSpec,
	shininess : 0.5,
});
const earthMes = new THREE.Mesh(earthGeo2, earthmat);
earthMes.rotation.z= tilt;

earthSys.add(earthMes);

//earth cloud
const cloudGeo = new THREE.SphereGeometry(r+1+5,s,s);
const cloudMat = new THREE.MeshPhongMaterial({
	map: loader.load(require("../assets/earthCl.jpg")),
	transparent : true,
	opacity : 0.5,
});

const cloud = new THREE.Mesh(cloudGeo,cloudMat);
earthSys.add(cloud);


//earth path
const earthPath = new THREE.RingGeometry(100+3*x, 100.5+3*x, 100);
const earthPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const earthPathMesh = new THREE.Mesh(earthPath, earthPathMaterial);
earthPathMesh.rotateX(Math.PI / 2);
//mercuryPathMesh.rotateY(-0.15);
scene.add(earthPathMesh);

//earth axis

const axisPoint =[
	new THREE.Vector3(0,35,0),
	new THREE.Vector3(0,-35,0),
];
const axisgeo = new THREE.BufferGeometry().setFromPoints(axisPoint);
const axis = new THREE.Line(
	axisgeo,
	new THREE.LineBasicMaterial({color: 0x330000, transparent:true, opacity:0.5})
);

axis.rotation.z=tilt;
earthSys.add(axis);

//moon




const moonGeo = new THREE.SphereGeometry(3,40,20);
const moonMat = new THREE.MeshStandardMaterial({
	map : loader.load(require("../assets/moon.jpg")),
	bumpMap : loader.load (require("../assets/moonBm.jpg")),
	bumpScale : 0.5,
	
});
const moonMesh = new THREE.Mesh(moonGeo, moonMat);
moonMesh.position.set(20,5,5);
earthSys.add(moonMesh);

scene.add(earthSys);



// earth


const probe = new THREE.Group();
const earthGeo = new THREE.BoxGeometry(15, 15, 10);
const earthcone = new THREE.ConeGeometry(10,15);
const stick = new THREE.CylinderGeometry(.5,.5,25);
const ash = loader.load(require("../assets/ash.jpg"));
const dash = loader.load(require("../assets/dash.jpg"));
const gold = loader.load(require("../assets/golden.jpg"));
const ashMAt = new THREE.MeshStandardMaterial({ map: ash });
const goldMAt = new THREE.MeshStandardMaterial({ map: gold });
const stickMat = new THREE.MeshStandardMaterial({map:dash});
const probe2 = new THREE.Mesh(earthGeo, goldMAt);
const probe3 = new THREE.Mesh(earthcone, ashMAt);
const probe4 = new THREE.Mesh(stick,stickMat);
const probe5 = new THREE.Mesh(stick,stickMat);

probe3.position.set(8,0,50);
probe3.rotateZ(1.75);
probe4.position.set(-8, 0, 50);
probe4.rotateZ(1.25);
probe5.rotateZ(1.75);
probe5.position.set(-8, 0, 50);
probe2.position.set(0, 0, 50);
probe.add(probe2);
probe.add(probe3);
probe.add(probe4);
probe.add(probe5);
//probe.rotateX(0.5);

scene.add(probe);
// // earth orbit path visualization
// const earthPath = new THREE.RingGeometry(100, 100.5, 100);
// const earthPathMaterial = new THREE.MeshBasicMaterial({
// 	color: 0xffffff,
// 	opacity: 0.5,
// 	transparent: true,
// 	side: THREE.DoubleSide,
// });
// const earthPathMesh = new THREE.Mesh(earthPath, earthPathMaterial);
// earthPathMesh.rotateX(Math.PI / 2);
// earth.rotateY(-0.09);
// scene.add(earthPathMesh);

// mars
const marsGeo = new THREE.SphereGeometry(3+r, 32, 32);
const marsTexture = loader.load(require("../assets/mars.jpeg"));
const marsMaterial = new THREE.MeshStandardMaterial({ map: marsTexture });
const mars = new THREE.Mesh(marsGeo, marsMaterial);
mars.position.set(0, 0, 120);
mars.rotateX(0.5);
scene.add(mars);
// mars orbit path visualization
const marsPath = new THREE.RingGeometry(120+4*x, 120.5+4*x, 100);
const marsPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const marsPathMesh = new THREE.Mesh(marsPath, marsPathMaterial);
marsPathMesh.rotateX(Math.PI / 2);
scene.add(marsPathMesh);

// jupiter
const jupiterGeo = new THREE.SphereGeometry(10+r, 32, 32);
const jupiterTexture = loader.load(require("../assets/jupiter.jpeg"));
const jupiterMaterial = new THREE.MeshStandardMaterial({ map: jupiterTexture });
const jupiter = new THREE.Mesh(jupiterGeo, jupiterMaterial);
jupiter.position.set(0, 0, 160);
scene.add(jupiter);
// jupiter orbit path visualization
const jupiterPath = new THREE.RingGeometry(160+5*x, 160.5+5*x, 100);
const jupiterPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const jupiterPathMesh = new THREE.Mesh(jupiterPath, jupiterPathMaterial);
jupiterPathMesh.rotateX(Math.PI / 2);
scene.add(jupiterPathMesh);

// saturn
const saturnGeo = new THREE.SphereGeometry(9.5+r, 32, 32);
const saturnTexture = loader.load(require("../assets/saturn.jpeg"));
const saturnMaterial = new THREE.MeshStandardMaterial({ map: saturnTexture });
const saturn = new THREE.Mesh(saturnGeo, saturnMaterial);
saturn.position.set(0, 0, 200);
saturn.rotateX(0.55);
scene.add(saturn);
// saturn orbit path visualization
const saturnPath = new THREE.RingGeometry(200+7*x, 200.5+7*x, 100);
const saturnPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const saturnPathMesh = new THREE.Mesh(saturnPath, saturnPathMaterial);
saturnPathMesh.rotateX(Math.PI / 2);
scene.add(saturnPathMesh);

// uranus
const uranusGeo = new THREE.SphereGeometry(6+r, 32, 32);
const uranusTexture = loader.load(require("../assets/uranus.jpeg"));
const uranusMaterial = new THREE.MeshStandardMaterial({ map: uranusTexture });
const uranus = new THREE.Mesh(uranusGeo, uranusMaterial);
uranus.position.set(0, 0, 240);
uranus.rotateX(1);
scene.add(uranus);
// uranus orbit path visualization
const uranusPath = new THREE.RingGeometry(240+8*x, 240.5+8*x, 100);
const uranusPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const uranusPathMesh = new THREE.Mesh(uranusPath, uranusPathMaterial);
uranusPathMesh.rotateX(Math.PI / 2);
uranusPathMesh.rotateY(Math.sin(0.1) * -0.5);
scene.add(uranusPathMesh);

// neptune
const neptuneGeo = new THREE.SphereGeometry(6+r, 32, 32);
const neptuneTexture = loader.load(require("../assets/neptune.jpeg"));
const neptuneMaterial = new THREE.MeshStandardMaterial({ map: neptuneTexture });
const neptune = new THREE.Mesh(neptuneGeo, neptuneMaterial);
neptune.rotateX(0.6);
neptune.position.set(0, 0, 280);
scene.add(neptune);
// neptune orbit path visualization
const neptunePath = new THREE.RingGeometry(280+9*x, 280.5+9*x, 100);
const neptunePathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const neptunePathMesh = new THREE.Mesh(neptunePath, neptunePathMaterial);
neptunePathMesh.rotateX(Math.PI / 2);
scene.add(neptunePathMesh);

// pluto
const plutoGeo = new THREE.SphereGeometry(2+r, 32, 32);
const plutoTexture = loader.load(require("../assets/pluto.png"));
const plutoMaterial = new THREE.MeshStandardMaterial({ map: plutoTexture });
const pluto = new THREE.Mesh(plutoGeo, plutoMaterial);
pluto.position.set(0, 0, 340);
scene.add(pluto);
// pluto orbit path visualization
const plutoPath = new THREE.RingGeometry(340+10*x, 340.5+10*x, 100);
const plutoPathMaterial = new THREE.MeshBasicMaterial({
	color: 0xffffff,
	opacity: 0.5,
	transparent: true,
	side: THREE.DoubleSide,
});
const plutoPathMesh = new THREE.Mesh(plutoPath, plutoPathMaterial);
plutoPathMesh.rotateX(Math.PI / 2);
plutoPathMesh.rotateY(Math.sin(0.1) * 0.55);
scene.add(plutoPathMesh);

// saturn ring
const saturnRingGeo = new THREE.RingGeometry(15+r, 20, 32);
const saturnRingTexture = loader.load(require("../assets/saturn-ring.png"));
const saturnRingMaterial = new THREE.MeshStandardMaterial({
	map: saturnRingTexture,
	side: THREE.DoubleSide,
	transparent: true,
	opacity: 0.8,
});
const saturnRing = new THREE.Mesh(saturnRingGeo, saturnRingMaterial);
saturnRing.rotateX(45);
saturnRing.position.set(0, 0, 200);
scene.add(saturnRing);

// factors for slider
let orbitFactor = 1;
let rotateFactor = 1;

// slider stuff (for orbit and rotation)
document.getElementById("myRange").step = 0.1;
let slider = document.getElementById("myRange");
let output = document.getElementById("demo");
output.innerHTML = slider.value;
// Update the current slider value (each time you drag the slider handle)
slider.oninput = () => {
	output.innerHTML = slider.value;
	orbitFactor = slider.value;
	rotateFactor = slider.value;
};

// change to planet view continuously when planet is clicked
// because of different size planets, camera positions have to change each time
const mercuryView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(30, 0, 5);
	const objectPosition = new Vector3();
	mercury.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const venusView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 5);
	const objectPosition = new Vector3();
	venus.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const earthView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 5);
	const objectPosition = new Vector3();
	earthSys.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const marsView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 5);
	const objectPosition = new Vector3();
	mars.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const jupiterView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 20);
	const objectPosition = new Vector3();
	jupiter.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const saturnView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(42, 0, 30);
	const objectPosition = new Vector3();
	saturn.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const uranusView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 15);
	const objectPosition = new Vector3();
	uranus.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const neptuneView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(32, 0, 15);
	const objectPosition = new Vector3();
	neptune.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const plutoView = () => {
	controls.enabled = false;
	const cameraOffset = new Vector3(30, 0, 15);
	const objectPosition = new Vector3();
	pluto.getWorldPosition(objectPosition);
	camera.position.copy(objectPosition).add(cameraOffset);
	camera.lookAt(objectPosition);
};

const freeLook = () => {
	camera.position.setZ(50);
	camera.position.setX(200);
	camera.position.setY(20);
	const controls = new OrbitControls(camera, renderer.domElement);
	controls.minDistance = 50;
	controls.maxDistance = 900;
	controls.enabled = true;
	const minPan = new THREE.Vector3(-400, -400, -400);
	const maxPan = new THREE.Vector3(400, 400, 400);

	var _v = new THREE.Vector3();

	controls.addEventListener("change", function () {
		_v.copy(controls.target);
		controls.target.clamp(minPan, maxPan);
		_v.sub(controls.target);
		camera.position.sub(_v);
	});
};

// flags to switch between planet views
let freeCheck = false;
let mercuryCheck = false;
let venusCheck = false;
let earthCheck = false;
let marsCheck = false;
let jupiterCheck = false;
let saturnCheck = false;
let uranusCheck = false;
let neptuneCheck = false;
let plutoCheck = false;

const freeLookInstructions = () => {
	// if free look is clicked, display movement container
	document.getElementById("movement-container").style.display = "flex";
};

// api call to get planet info
const getInfo = (index) => {
	// fetch data from api and set state
	fetch("https://api.le-systeme-solaire.net/rest/bodies/")
		.then((response) => response.json())
		.then((data) => {
			document.getElementById("movement-container").style.display = "none";
			// console.log(data.bodies);
			// create card with data
			let card = document.createElement("div");
			card.classList.add("card");
			let cardBody = document.createElement("div");
			cardBody.classList.add("card-body");
			let cardTitle = document.createElement("h2");
			cardTitle.classList.add("card-title");
			cardTitle.innerHTML = "Name: " + data.bodies[index].englishName;
			let cardText = document.createElement("p");
			cardText.classList.add("card-text");
			cardText.innerHTML = "Body Type: " + data.bodies[index].bodyType;
			let cardText2 = document.createElement("p");
			cardText2.classList.add("card-text");
			if (data.bodies[index].moons == null) {
				cardText2.innerHTML = "Moons: 0";
			} else {
				cardText2.innerHTML = "Moons: " + data.bodies[index].moons.length;
			}
			let cardText3 = document.createElement("p");
			cardText3.classList.add("card-text");
			cardText3.innerHTML =
				"Mass: " + data.bodies[index].mass.massValue + " * 10^" + data.bodies[index].mass.massExponent + " kg";
			let cardText4 = document.createElement("p");
			cardText4.classList.add("card-text");
			cardText4.innerHTML = "Density: " + data.bodies[index].density + " g/cm^3";
			let cardText5 = document.createElement("p");
			cardText5.classList.add("card-text");
			cardText5.innerHTML = "Gravity: " + data.bodies[index].gravity + " m/s^2";
			let cardText6 = document.createElement("p");
			cardText6.classList.add("card-text");
			cardText6.innerHTML = "Escape Speed: " + data.bodies[index].escape + " m/s";
			let cardText7 = document.createElement("p");
			cardText7.classList.add("card-text");
			cardText7.innerHTML = "Mean Radius: " + data.bodies[index].meanRadius + " km";
			let cardText8 = document.createElement("p");
			cardText8.classList.add("card-text");
			cardText8.innerHTML = "Sideral Orbit: " + data.bodies[index].sideralOrbit + " days";
			let cardText9 = document.createElement("p");
			cardText9.classList.add("card-text");
			cardText9.innerHTML = "Sideral Rotation: " + data.bodies[index].sideralRotation + " hours";
			let cardText10 = document.createElement("p");
			cardText10.classList.add("card-text");
			cardText10.innerHTML = "Average Temperature: " + data.bodies[index].avgTemp + " K";
			cardBody.appendChild(cardTitle);
			card.appendChild(cardBody);
			cardBody.appendChild(cardText);
			cardBody.appendChild(cardText2);
			cardBody.appendChild(cardText3);
			cardBody.appendChild(cardText4);
			cardBody.appendChild(cardText5);
			cardBody.appendChild(cardText6);
			cardBody.appendChild(cardText7);
			cardBody.appendChild(cardText8);
			cardBody.appendChild(cardText9);
			cardBody.appendChild(cardText10);
			document.getElementById("card-container").appendChild(card);
		})
		.catch((error) => console.log(error));
	// remove all cards if they exist
	if (document.getElementById("card-container").childNodes.length > 0) {
		document.getElementById("card-container").innerHTML = "";
	}
};

document.getElementById("look").addEventListener("click", () => {
	freeLookInstructions();
	freeCheck = true;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	// dont want this in animation look or else there are bugs
	freeLook();
	if (document.getElementById("card-container").childNodes.length > 0) {
		document.getElementById("card-container").innerHTML = "";
	}
});
document.getElementById("mercury").addEventListener("click", () => {
	mercuryCheck = true;
	freeCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(240);
});
document.getElementById("venus").addEventListener("click", () => {
	venusCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(244);
});
// document.getElementById("earthSys").addEventListener("click", () => {
// 	earthCheck = true;
// 	freeCheck = false;
// 	mercuryCheck = false;
// 	venusCheck = false;
// 	marsCheck = false;
// 	jupiterCheck = false;
// 	saturnCheck = false;
// 	uranusCheck = false;
// 	neptuneCheck = false;
// 	plutoCheck = false;
// 	getInfo(243);
// });
document.getElementById("mars").addEventListener("click", () => {
	marsCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(239);
});
document.getElementById("jupiter").addEventListener("click", () => {
	jupiterCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(238);
});
document.getElementById("saturn").addEventListener("click", () => {
	saturnCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(241);
});
document.getElementById("uranus").addEventListener("click", () => {
	uranusCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	neptuneCheck = false;
	plutoCheck = false;
	getInfo(199);
});
document.getElementById("neptune").addEventListener("click", () => {
	neptuneCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	plutoCheck = false;
	getInfo(219);
});
document.getElementById("pluto").addEventListener("click", () => {
	plutoCheck = true;
	freeCheck = false;
	mercuryCheck = false;
	venusCheck = false;
	earthCheck = false;
	marsCheck = false;
	jupiterCheck = false;
	saturnCheck = false;
	uranusCheck = false;
	neptuneCheck = false;
	getInfo(208);
});

// all movement stuff done here
function System() {
	const animate = (orbitFactor, rotateFactor) => {

    //    if(tt){
	// 	tt.rotation.y+=EARTH_YEAR * 0.25;
	// 	tt.position.x = Math.sin(timestamp * 5) * (65+x) ;
	// 	tt.position.z = Math.cos(timestamp * 5) * (65+x);
	//    }

		renderer.render(scene, camera);
		const EARTH_YEAR = (rotateFactor * (50 * Math.PI * (1 / 60) * (1 / 60)))/10;
		// relative rotations
		sun.rotation.y += EARTH_YEAR * 0.25;
		mercury.rotation.y += EARTH_YEAR * 0.5;
		venus.rotation.y -= EARTH_YEAR * 0.1;
		earthSys.rotation.y += EARTH_YEAR;
	//
		probe.rotation.y+= EARTH_YEAR* .9;
		
		mars.rotation.y += EARTH_YEAR * 1.05;
		jupiter.rotation.y += EARTH_YEAR * 4;
		saturn.rotation.y += EARTH_YEAR * 4;
		uranus.rotation.y -= EARTH_YEAR * 3;
		neptune.rotation.y += EARTH_YEAR * 3;
		pluto.rotation.y += EARTH_YEAR * 0.75;

		//tt.rotation.y += EARTH_YEAR * 0.75;

		timestamp = orbitFactor * (Date.now() * 0.0001);

		// relative orbits
		
		mercury.position.x = Math.sin(timestamp * 5) * (60+x) ;
		mercury.position.z = Math.cos(timestamp * 5) * (60+x);
		mercury.position.y = Math.sin(timestamp * 5) * -10;
		//tt.position.x = Math.sin(timestamp * 5) * (65+x) ;
		//tt.position.z = Math.cos(timestamp * 5) * (65+x);

		venus.position.x = Math.sin(timestamp * 4) * (80+2*x);
		venus.position.z = Math.cos(timestamp * 4) * (80+2*x);

		probe.position.x = Math.sin(timestamp * 5) * (55+x);
		probe.position.z = Math.cos(timestamp * 5) * (55+x);

		earthSys.position.x = Math.sin(timestamp * 3) * (100+3*x);
		earthSys.position.z = Math.cos(timestamp * 3) * (100+3*x);

		mars.position.x = Math.sin(timestamp * 2) * (120+4*x);
		mars.position.z = Math.cos(timestamp * 2) * (120+4*x);

		jupiter.position.x = Math.sin(timestamp * 0.8) * (160+5*x);
		jupiter.position.z = Math.cos(timestamp * 0.8) * (160+5*x);

		saturn.position.x = Math.sin(timestamp * 0.5) * (200+7*x);
		saturn.position.z = Math.cos(timestamp * 0.5) * (200+7*x);
		saturnRing.position.x = Math.sin(timestamp * 0.5) * (200+7*x);
		saturnRing.position.z = Math.cos(timestamp * 0.5) * (200+7*x);

		uranus.position.x = Math.sin(timestamp * 0.4) * (240+8*x);
		uranus.position.z = Math.cos(timestamp * 0.4) * (240+8*x);
		uranus.position.y = Math.sin(timestamp * 0.4) * -10;

		neptune.position.x = Math.sin(timestamp * 0.2) * (280+9*x);
		neptune.position.z = Math.cos(timestamp * 0.2) * (280+9*x);

		pluto.position.x = Math.sin(timestamp * 0.1) * (340+10*x);
		pluto.position.z = Math.cos(timestamp * 0.1) * (340+10*x);
		pluto.position.y = Math.sin(timestamp * 0.1) * 20;

		if (mercuryCheck) {
			mercuryView();
		} else if (venusCheck) {
			venusView();
		} else if (earthCheck) {
			earthView();
		} else if (marsCheck) {
			marsView();
		} else if (jupiterCheck) {
			jupiterView();
		} else if (saturnCheck) {
			saturnView();
		} else if (uranusCheck) {
			uranusView();
		} else if (neptuneCheck) {
			neptuneView();
		} else if (plutoCheck) {
			plutoView();
		}
		requestAnimationFrame(System);
	};
	animate(orbitFactor, rotateFactor);
}
export default System;
